import React from 'react';
import styled from 'styled-components';

import history from '../../history';

import Table from 'components/table';
import {LinkSmall} from 'components/buttons';

const Thead = styled.thead`
  tr > th {
    color: #000 !important;
  }
`;

const DoctorsList = ({ doctors }) => {
  const handleLinkClick = e => e.stopPropagation()

  return <Table hover>
    <Thead>
    <tr>
      <th>ПІБ лікаря</th>
      <th>Спеціальність</th>
      <th></th>
    </tr>
    </Thead>
    <tbody>
    {doctors.map((item, i) => (
      <tr key={i} onClick={() => {history.push(`/admin/doctors/detail/${item.get('id')}`)}}>
        <td>{item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')} {item.get('user_data').get('middle_name')}</td>
        <td><span>Спеціальність: </span>{item.get('profession_classification_data').get('profession_title')}</td>
        <td><LinkSmall to={`/admin/doctors/detail/${item.get('id')}`} onClick={handleLinkClick}>Детальніше</LinkSmall></td>
      </tr>
    ))}
    </tbody>
  </Table>
}

export default DoctorsList;



// WEBPACK FOOTER //
// ./src/admin/doctors/doctors-list.js